<template>
  <DBox
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_artist_payment')}`"
    @add_click="onAddInvoiceLine"
    :id="'cmp-accounting-invoices-invoice_sidewindow-artist_payments'"
  >
    <div style="height: calc(100% - 32px)">
      <NTable
        class="invcoie-line-list dbox1"
        :headers="headers"
        :items="selectedInvoice.artist_payments"
        :config="tableConfig"
        :showNoItems="false"
        :id="'accounting-invoices-invoice_sidewindow-artist_payments'"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('payment_date_string')">
              <TextField2
                type="text"
                :showLabel="false"
                id="text"
                class="dbox1"
                :disabled="selectedInvoice.disabled"
                :value="item['date']"
                :bb="'0px'"
                @change="(e) => onTextFieldChange(e, item)"
              />
            </td>
            <td v-bind="tdcon('recipient')">
              <!-- <TextField
                type="text"
                :typeahead="true"
                :showLabel="false"
                id="recipient"
                class="fc-control"
                :options="calendar_date_artistsTV"
                :disabled="selectedInvoice.disabled"
                :value="item['recipient']"
                :bb="'0px'"
                @valuechanged="onDropdownSearch"
                @blur="(e) => onTextFieldChange(e, item)"
              ></TextField> -->
              <!-- <TextField
                :id="'recipient'"
                :showLabel="false"
                :bb="'0px'"
                class="fc2-textfield"
                v-bind="typeAheadTextFieldConfig"
                :options="calendar_date_artistsTV"
                :disabled="selectedInvoice.disabled"
                :value="item['recipient']"
                @selected="(e) => onDropdownSearchBlur(e, item)"
                @valuechanged="onDropdownSearch"
                @blur="(name, value) => onTextFieldBlur(name, value, item)"
              ></TextField> -->
              <Dropdown2
                isSearchable
                class="dbox1"
                id="recipient"
                :listHeight="100"
                :showLabel="false"
                style="max-height: 150px"
                :disabled="selectedInvoice.disabled"
                :options="calendar_date_artistsTV"
                :placeholder="`${$t('select')} ${$t('recipient')}`"
                :selected="{
                  text: item['recipient'],
                  value: item['recipient'],
                }"
                v-on:selectedChange="(e) => onDropdownChange(item, e)"
                @searched="onDropdownSearch"
                @searchedBlur="(e) => onDropdownSearchBlur(e, item)"
                :bb="'0px'"
              ></Dropdown2>
            </td>
            <td v-bind="tdcon('notes')">
              <TextField2
                type="text"
                :showLabel="false"
                id="notes"
                :disabled="selectedInvoice.disabled"
                :value="item['notes']"
                :bb="'0px'"
                @change="(e) => onTextFieldChange(e, item)"
              />
            </td>
            <td v-bind="tdcon('amount')">
              <TextField2
                ta="right"
                type="number"
                :showLabel="false"
                id="amount"
                class="dbox1"
                :disabled="selectedInvoice.disabled"
                :value="item['amount']"
                :bb="'0px'"
                @change="(e) => onTextFieldChange(e, item)"
              />
            </td>
            <td v-bind="tdcon('currency')">
              <Dropdown2
                class="dbox1"
                :showLabel="false"
                :disabled="selectedInvoice.disabled"
                :options="currencyTV"
                :selected="currencyTV.find((v) => v.value == item.currency_id)"
                :placeholder="$t('default_currency')"
                v-on:selectedChange="(e) => onCurrencyChange(item, e)"
                :bb="'0px'"
              />
              <!-- <span>{{
                currencyTV.find((v) => v.value == item.currency_id).text
              }}</span> -->
            </td>
            <td v-bind="tdcon('exchangerate')">
              <TextField2
                type="number"
                :showLabel="false"
                ta="right"
                id="exchangerate"
                class="dbox1"
                :disabled="selectedInvoice.disabled"
                :value="item['exchangerate']"
                :bb="'0px'"
                @change="(e) => onTextFieldChange(e, item)"
              />
            </td>
            <td v-bind="tdcon('EUR')">
              <span style="font-weight: 700; text-align: right">{{
                item["amountEUR"]
              }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <div style="padding-left: 2px" class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onDeleteInvoiceLine(item)"
                  :alt="$t('delete_invoice_line')"
                  :title="$t('delete_invoice_line')"
                />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <div class="flex-container">
      <div class="forward-checkbox">
        <div class="checkboxcontainer" style="">
          <div class="dt-checkbox v2 s2">
            <input
              type="checkbox"
              :name="'invoice_project'"
              :id="'invoice_project'"
              :checked="selectedInvoice.invoice.forward_completed_flag == 1"
              @click="(e) => onInvoiceSelectForward(e)"
            />
            <div class="checkmark"></div>
          </div>
        </div>
        <div class="checkbox-label ut-flex">
          <div class="dt-icon-container">
            <img
              src="static/icons/fast-forward.svg"
              class="dt-icon s16p"
              :alt="$t('forwarding_complete')"
              :title="$t('forwarding_complete')"
            />
          </div>
          <span style="margin-left: 10px">
            {{ $t("forwarding_complete") }}
          </span>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; width: fit-content">
        <div class="total-artist">{{ $t("total_artist") }}</div>
        <div class="total-value">
          {{ totalAmount }} {{ $store.getters.account.client.default_currency }}
        </div>
      </div>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { EventHooks } from "../../../../plugins/text-field";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { mapGetters } from "vuex";
import { parseNumber } from "../../../../utility";
import { tv } from "../../../../models/text-value.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { InvoiceForwardService } from "../../services/invoice-forward.service";
import TextInput from "../../../../plugins/text-field/text-input";
import DatePicker from "@plugins/text-field/date-picker";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  components: {
    NTable,
    DBox,
    DatePicker,
  },
  props: {
    selectedInvoice: {
      required: true,
    },
  },
  data: () => ({
    textFieldConfig: {
      height: 42,
      showEditIconOnHover: false,
      box: true,
      showValidationIcons: false,

      validationEvent: EventHooks.OnBlur,
      valueChangedEvent: EventHooks.OnBlur,
    },
    typeAheadTextFieldConfig: {
      height: 42,
      showEditIconOnHover: false,
      box: true,
      showValidationIcons: false,
      validationEvent: EventHooks.OnKeyup,
      valueChangedEvent: EventHooks.OnKeyup,
      typeahead: true,
    },
    searchedValue: "",
    tableConfig: createNTableConfig({
      fullHeight: true,
      headerStyle: 3,
    }),
  }),
  computed: {
    headers: () => [
      createTableHeader("payment_date_string", { minw: 120, f: 0.9 }),
      createTableHeader("recipient", { f: 1.5 }),
      createTableHeader("notes", { f: 2.5 }),
      createTableHeader("amount", { ta: "right" }),
      createTableHeader("currency"),
      createTableHeader("exchangerate", { minw: 120, ta: "right", f: 1.0 }),
      createTableHeader("EUR", { f: 0.8, ta: "right" }),
      createTableHeader("options", { text: false, mw: 30, ta: "left" }),
    ],
    vat_handling: function () {
      return this.selectedInvoice.invoice.vat_handling;
    },
    invoice: function () {
      return this.selectedInvoice?.invoice;
    },
    currencyTV: function () {
      return this.selectedInvoice.currencies.map((v) => {
        return { text: v.currency_iso, value: v.currency_id };
      });
    },
    calendar_date_artistsTV: function () {
      return this.selectedInvoice?.calendar_date_artistsTV.filter((e) =>
        e.text.toLowerCase().includes(this.searchedValue.toLowerCase())
      );
    },
    totalAmount: function () {
      let total = 0.0;
      this.selectedInvoice.artist_payments.forEach((element) => {
        if (element.amount) {
          var sys_cur_val = Number(
            element.amount * element.exchangerate
          ).toFixed(2);
          total += parseFloat(sys_cur_val);
        }
      });
      return total;
    },
  },
  methods: {
    onInvoiceSelectForward: function (e) {
      const checked = e.target.checked;

      console.log("WERE", this.selectedInvoice);
      // if(checked){
      //   InvoiceForwardService.postForwardCompletedFlag(this.selectedInvoice.invoice_id,1);
      // }
      // else
      // {
      //   InvoiceForwardService.postForwardCompletedFlag(this.selectedInvoice.invoice_id,0);
      // }

      this.$emit("changeInvoice", {
        name: "forward_completed_flag",
        value: checked ? 1 : 0,
      });
    },
    getInvoicelineAmount: function (invoiceline) {
      // return CURRENCY(parseNumber(invoiceline.qty, 1) * parseNumber(invoiceline.price, 0));
      return this.$dft.curr(
        parseNumber(invoiceline.qty, 1) * parseNumber(invoiceline.price, 0),
        this.selectedInvoice.invoiceCurrency.currency_iso
      );
    },

    onCurrencyChange: function (item, value) {
      this.$emit("changed", {
        name: "currency_id",
        value: value.value,
        item,
      });
    },
    onRadioChange: function (event) {
      const value = event.target.value;
      this.$emit("change_tax_deduc", { name: "vat_handling", value });
    },
    onDropdownChange: function (item, value) {
      item["recipient"] = value.value;
      this.$emit("changed", {
        name: "recipient",
        value: value.value,
        item,
      });
    },
    onAddInvoiceLine: async function () {
      //        let  artist_pay=await InvoiceForwardService.getIvoiceDetails(this.selectedInvoice.invoice_id)
      //  console.log("RRRRRRRRR",artist_pay)
      //console.log("INVOICE",this.selectedInvoice)
      this.$emit("invoiceline_added", true);
    },
    onDeleteInvoiceLine: async function (item) {
      const confirmationResult = await confirmDelete("Invoice Line");
      if (confirmationResult === "OK") {
        this.$emit("artistpayments_deleted", item);
      }
    },
    onDateUpdate: function ({ name, value }) {
      // console.log(name, value);
      this.$emit("changed", {
        name,
        value,
        item,
      });
    },
    onDropdownSearch: async function (value) {
      console.log("value", value);
      this.searchedValue = value;
    },

    onDropdownSearchBlur: async function (e, item) {
      item["recipient"] = e;
      this.$emit("changed", {
        name: "recipient",
        value: e,
        item,
      });
    },
    onTextFieldBlur: function (name, value, item) {
      console.log(value);
      console.log(name);
    },
    onTextFieldChange: function ({ name, value }, item) {
      console.log({ name, value });
      item[name] = value;
      if (name == "price") {
        value = (+value).toFixed(2);
      }
      this.$emit("changed", {
        name,
        value,
        item,
      });
    },
    //MARK: Methods
  },
  mounted: async function () {
    // let  artist_pay=await InvoiceForwardService.getIvoiceDetails(this.selectedInvoice.invoice_id)
    console.log("PAY ARTIST", this.selectedInvoice.currencies);
  },
};
</script>

<style lang="scss">
.cmp-accounting-invoices-invoice_sidewindow-artist_payments {
  .dropdown--list {
    max-height: 150px !important;
  }
  .dt-ntable {
    .amount {
      input {
        text-align: right;
      }
    }
  }
  .flex-container {
    display: flex;
    flex-direction: row;
    padding-top: 10px;
    justify-content: space-between;
    margin-right: 28px;

    .forward-checkbox {
      flex: 0.8;
      display: flex;
      flex-direction: row;
      margin-left: 10px;
      .checkboxcontainer {
        margin-top: auto;
        margin-bottom: auto;
        max-width: 50px;
        margin-right: 8px;
      }
      .checkbox-label {
        margin-left: 4px;
      }
    }
    .total-artist {
      //flex: 0.1;
      padding-right: 20px;
    }
    .artist-value {
      flex: 0.1;
    }
  }
  // .dt-input-box--container {
  //   --tf-margin: 0px !important;
  //   .input-container {
  //     bottom: 11px !important;
  //   }
  //   &:active,
  //   &:focus {
  //     --fc2-bdc: var(--default-focus-bdc);
  //     padding: var(--fc2-tf-padding-focus);
  //     margin: var(--fc2-tf-margin-focus);
  //     border-radius: 0px;
  //   }
  // }
}
</style>
